import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id CB038F2A-85DE-4F59-B694-D4805D66322B
 * name microsoft-bing
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microsoft-bing.svg
 * tags
 * - Brand / Logo 
 */
export const MicrosoftBingIcon = createSvgIcon(<><path d="M5,3V19L8.72,21L18,15.82V11.73H18L9.77,8.95L11.38,12.84L13.94,14L8.7,16.92V4.27L5,3" /></>, 'MicrosoftBingIcon');
export default MicrosoftBingIcon